import React, { useContext } from "react";
import SettingsLink from "./SettingsLink";
import { GlobalContext } from "../../context/GlobalState";

const SettingsMobile = () => {
  const { userData, currentWorkspace } = useContext(GlobalContext);

  const isAdmin = userData.isAdmin || (userData.hasOwnProperty('roles') && userData.roles.hasOwnProperty(currentWorkspace.id) && userData.roles[currentWorkspace.id].role === 'admin');

  return (
    <div>
      <SettingsLink route="account" />
      {isAdmin && <SettingsLink route="billing" />}
      {isAdmin && <SettingsLink route="users" />}
      <SettingsLink route="switch" />
    </div>
  );
};

export default SettingsMobile;
